module.exports = __webpack_public_path__ + "img/interface OneB Mapper_5.1824c125.jpg";